import { axiosClient } from "./axiosClient"

export const CHEQUE_PATH = '/api/v1/cheque'

export const getPageCheques = ({ search = "", lastId = '', id = "", owner = '', currency = '', isEnabled = true, serialNumber = "" }) => {
    return axiosClient.get(`${CHEQUE_PATH}/page?search=${search}&lastId=${lastId}&id=${id}&owner=${owner}&currency=${currency}&isEnabled=${isEnabled}&serialNumber=${serialNumber}`)
}

export const addCheque = (body) => {
    return axiosClient.post(CHEQUE_PATH, body)
}

export const deleteCheque = (id) => {
    return axiosClient.delete(`${CHEQUE_PATH}/${id}`)
}

export const getChequeById = (id) => {
    return axiosClient.get(`${CHEQUE_PATH}/${id}`)
}

export const getChequeBySerialNumber = (serialNumber) => {
    return axiosClient.get(`${CHEQUE_PATH}/serial-number/${serialNumber}`)
}

export const updateCheque = (id, body) => {
    return axiosClient.put(`${CHEQUE_PATH}/${id}`, body)
}
